module.exports = __webpack_public_path__ + "img/de.702f527f.svg";